import { render } from "./AdminPage.vue?vue&type=template&id=48a51200&scoped=true&ts=true"
import script from "./AdminPage.vue?vue&type=script&lang=ts"
export * from "./AdminPage.vue?vue&type=script&lang=ts"

import "./AdminPage.vue?vue&type=style&index=0&id=48a51200&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48a51200"]])

export default __exports__